export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
            你有独家51吃瓜黑料线索？欢迎向我们投稿！51吃瓜爆料网严格保护爆料人隐私，
            优质爆料一经采用即享丰厚奖励。你的一条爆料可能就是下一个全网热搜。
          </p>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <div className="text-sm font-medium text-foreground-800 mb-1">邮箱投稿</div>
                <div className="text-xs text-foreground-500 break-all">tips@51chigua.com</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line text-xl text-accent-500"></i>
                </div>
                <div className="text-sm font-medium text-foreground-800 mb-1">在线投稿</div>
                <div className="text-xs text-foreground-500">填写表单快速提交</div>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-user-line text-xl text-secondary-500"></i>
                </div>
                <div className="text-sm font-medium text-foreground-800 mb-1">匿名保护</div>
                <div className="text-xs text-foreground-500">严格保密爆料人信息</div>
              </div>
            </div>

            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <i className="ri-send-plane-line text-lg"></i>
              立即投稿爆料
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}